import { IoMdCheckmark } from 'react-icons/io';
import { LuMinus } from 'react-icons/lu';

import ActionsButton from 'components/tables/AGGrid/ActionsButton';

const booleanCellRenderer = (params) =>
    params.value ? (
        <IoMdCheckmark fontSize="large" />
    ) : (
        <LuMinus fontSize="large" />
    );

/**
 * Builds the AG Grid column definitions for the Trunk Types table.
 *
 * @param {object}   params
 * @param {function} params.onEditTrunkType  Called with the row data when the edit action is clicked.
 * @returns {Array} AG Grid column definitions.
 */
export const getTrunkTypesTableColumns = ({ onEditTrunkType }) => [
    {
        headerName: 'Name',
        field: 'name',
        flex: 1,
        minWidth: 150,
        sort: 'desc',
    },
    {
        headerName: 'Header Value',
        field: 'headerValue',
        flex: 1,
        minWidth: 150,
    },
    {
        headerName: 'Teams Enabled',
        field: 'teamsEnabled',
        width: 150,
        cellStyle: () => ({ display: 'flex', alignItems: 'center' }),
        cellRenderer: booleanCellRenderer,
        valueFormatter: (params) => (params.value ? 'Yes' : 'No'),
    },
    {
        headerName: 'SIP Enabled',
        field: 'sipEnabled',
        width: 150,
        cellStyle: () => ({ display: 'flex', alignItems: 'center' }),
        cellRenderer: booleanCellRenderer,
        valueFormatter: (params) => (params.value ? 'Yes' : 'No'),
    },
    {
        headerName: 'Shared',
        field: 'shared',
        width: 120,
        cellStyle: () => ({ display: 'flex', alignItems: 'center' }),
        cellRenderer: booleanCellRenderer,
        valueFormatter: (params) => (params.value ? 'Yes' : 'No'),
    },
    {
        headerName: 'Action',
        maxWidth: 100,
        filter: false,
        suppressMovable: true,
        lockVisible: true,
        suppressColumnsToolPanel: true,
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        enableRowGroup: false,
        resizable: false,
        sortable: false,
        cellStyle: () => ({ display: 'flex', alignItems: 'center' }),
        lockPosition: 'right',
        cellRenderer: (params) => (
            <ActionsButton
                actions={[
                    {
                        label: 'Edit Trunk Type',
                        onClick: () => onEditTrunkType(params.data),
                    },
                ]}
            />
        ),
    },
];
